// extracted by mini-css-extract-plugin
export default {"header":"ViewCreationHeader_header__pDijC","nameInput":"ViewCreationHeader_nameInput__n88om"};